import { endpoints } from "@/utils/common/requests/endpoints";
import { useAction } from "@/utils/useQuery/useAction";

/**
 * @typedef {Object} DeleteCrewArg
 * @property {string} crewId
 */

/**
 * @returns {import("@/utils/useQuery/useAction").ActionReturn<DeleteCrewArg>}
 */
export function useDeleteCrew() {
	return useAction({
		url: (arg) => endpoints.crew.DELETE(arg.crewId),
		method: "delete",
	});
}
